import { useEffect, useState } from "react";
import { fetchIndicatorRangesByCity } from "../api/infoApi";

export function useIndicatorRanges(city, level = "Suburb") {
  const [ranges, setRanges] = useState({});
  const [loading, setLoading] = useState(Boolean(city));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!city) {
      setRanges({});
      setLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchIndicatorRangesByCity(city, level)
      .then((data) => { if (!cancelled) setRanges(data || {}); })
      .catch((err) => { if (!cancelled) setError(err); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [city, level]);

  return { ranges, loading, error };
}
